import catalog from "../shared/guidePublishSlots.generated.json";

const rawSlots = Array.isArray(catalog?.slots) ? catalog.slots : [];

export const GUIDE_PUBLISH_SLOTS = rawSlots.map((slot) => ({
  ...slot,
  id: String(slot.id || ""),
  routePath: String(slot.routePath || ""),
  routeTitle: String(slot.routeTitle || slot.routeLabel || slot.routePath || "Guide Route"),
  routeLabel: String(slot.routeLabel || slot.routeTitle || slot.routePath || "Guide Route"),
  sectionId: String(slot.sectionId || ""),
  sectionLabel: String(slot.sectionLabel || slot.sectionId || "Section"),
  mediaKey: String(slot.mediaKey || ""),
  mediaLabel: String(slot.mediaLabel || slot.mediaKey || "Media Slot"),
  plannedAssetPath: String(slot.plannedAssetPath || ""),
  plannedAssetRelativePath: String(slot.plannedAssetRelativePath || ""),
  categoryKey: String(slot.categoryKey || ""),
  categoryFolder: String(slot.categoryFolder || ""),
  mapName: String(slot.mapName || ""),
  subjectName: slot.subjectName ? String(slot.subjectName) : null,
}));

const guidePublishSlotById = new Map(
  GUIDE_PUBLISH_SLOTS.map((slot) => [slot.id, slot]),
);

export function getGuidePublishSlotById(slotId) {
  if (!slotId) {
    return null;
  }

  return guidePublishSlotById.get(slotId) || null;
}

export function getGuidePublishRoutes() {
  const routeMap = new Map();

  GUIDE_PUBLISH_SLOTS.forEach((slot) => {
    if (!slot.routePath || routeMap.has(slot.routePath)) {
      return;
    }

    routeMap.set(slot.routePath, {
      routePath: slot.routePath,
      routeTitle: slot.routeTitle,
      routeLabel: slot.routeLabel,
      categoryKey: slot.categoryKey,
      mapName: slot.mapName,
      subjectName: slot.subjectName,
    });
  });

  return [...routeMap.values()];
}

export function getGuidePublishSections(routePath) {
  const sectionMap = new Map();

  GUIDE_PUBLISH_SLOTS.forEach((slot) => {
    if (slot.routePath !== routePath || sectionMap.has(slot.sectionId)) {
      return;
    }

    sectionMap.set(slot.sectionId, {
      sectionId: slot.sectionId,
      sectionLabel: slot.sectionLabel,
      routePath: slot.routePath,
    });
  });

  return [...sectionMap.values()];
}

export function getGuidePublishSlotsForSection(routePath, sectionId) {
  return GUIDE_PUBLISH_SLOTS.filter(
    (slot) => slot.routePath === routePath && slot.sectionId === sectionId,
  );
}
